<template>
  <div class="row">
    <div class="col-3" v-if="showRepositorySelector">
      <repository-selector :repositories="repositories" v-model:selected="selectedRepos" />
    </div>
    <div class="col-3" v-if="showBranchSelectorComputed">
      <branch-selector
        :selectedRepositories="selectedRepos"
        :repositories="repositories"
        :repositoryBranches="repositoryBranches"
        :initialSelectedBranches="selectedBranches"
        @branchChange="handleBranchChange"
      />
    </div>
    <div :class="filterColumnClass">
      <select class="form-select" v-model="languageFilterValue" @change="emitFiltersChange">
        <option value="">All languages</option>
        <option value="ruby">Ruby</option>
        <option value="javascript">JavaScript</option>
      </select>
    </div>
    <div :class="filterColumnClass">
      <select class="form-select" v-model="versionFilterValue" @change="emitFiltersChange">
        <option value="">All versions</option>
        <option value="uptodate">Only up-to-date</option>
        <option value="outdated">Only outdated</option>
        <option value="major">New major (x.0.0)</option>
        <option value="minor">New minor (0.x.0)</option>
        <option value="patch">New patch (0.0.x*)</option>
      </select>
    </div>
    <div :class="filterColumnClass">
      <select class="form-select" v-model="securityFilterValue" @change="emitFiltersChange">
        <option value="">All packages</option>
        <option value="only">Packages with security warnings</option>
        <option value="except">Packages without security warnings</option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import RepositorySelector from "./RepositorySelector.vue";
import BranchSelector from "./BranchSelector.vue";

const props = defineProps({
  repositories: {
    type: Array,
    default: () => []
  },
  repositoryBranches: {
    type: Object,
    default: () => ({})
  },
  initialSelectedRepositories: {
    type: Array,
    default: () => []
  },
  selectedBranches: {
    type: Object,
    default: () => ({})
  },
  showBranchSelector: {
    type: Boolean,
    default: true
  },
  languageFilter: {
    type: String,
    default: ""
  },
  versionFilter: {
    type: String,
    default: ""
  },
  securityFilter: {
    type: String,
    default: ""
  }
});

const emit = defineEmits([
  "update:languageFilter",
  "update:versionFilter",
  "update:securityFilter",
  "update:selectedRepositories",
  "branchChange"
]);

const selectedRepos = ref([...props.initialSelectedRepositories]);
const languageFilterValue = ref(props.languageFilter);
const versionFilterValue = ref(props.versionFilter);
const securityFilterValue = ref(props.securityFilter);

const showRepositorySelector = computed(() => props.repositories.length > 0);
const showBranchSelectorComputed = computed(() => props.showBranchSelector && selectedRepos.value.length > 0);

const filterColumnClass = computed(() => {
  return showBranchSelectorComputed.value ? "col-2" : "col-3";
});

watch(selectedRepos, (newValue) => {
  emit("update:selectedRepositories", newValue);
});

watch(
  () => props.languageFilter,
  (newValue) => {
    languageFilterValue.value = newValue;
  }
);

watch(
  () => props.versionFilter,
  (newValue) => {
    versionFilterValue.value = newValue;
  }
);

watch(
  () => props.securityFilter,
  (newValue) => {
    securityFilterValue.value = newValue;
  }
);

const emitFiltersChange = () => {
  emit("update:languageFilter", languageFilterValue.value);
  emit("update:versionFilter", versionFilterValue.value);
  emit("update:securityFilter", securityFilterValue.value);
};

const handleBranchChange = (branchesByRepo) => {
  emit("branchChange", branchesByRepo);
};
</script>
